/**
 * #138 — Iconos PNG personalizados Zerviz (paridad legacy).
 *
 * Helper que mapea channel/provider/feature → asset PNG en /public/icons.
 * Los assets vienen del legacy `src/iconos/` (38 PNG marca Zerviz) que
 * fueron copiados a builder-spa/public/icons. Si en algún momento se
 * migran a SVG, este es el único punto a actualizar.
 *
 * Uso:
 *   <ChannelIcon kind="whatsapp" size={24} />
 *   <ChannelIcon kind="notifications" size={32} />
 */

type IconKind =
  | 'webchat'
  | 'whatsapp'
  | 'ia'
  | 'notifications'
  | 'meta'
  | 'flow'
  | 'reports'
  | 'realtime'
  | 'api'
  | 'home'
  | 'analytics'
  | 'security'
  | 'channels'
  | 'cloud';

const ICON_MAP: Record<IconKind, string> = {
  webchat: 'icon_webchat.png',
  whatsapp: 'icon_whatsapp.png',
  ia: 'icon_IA.png',
  notifications: 'notifications.png',
  meta: 'meta.png',
  flow: 'flow.png',
  reports: 'IconZerviz- Stadistics.png',
  realtime: 'IconZerviz- RealTime.png',
  api: 'IconZerviz- API.png',
  home: 'IconZerviz- Harmony.png',
  analytics: 'IconZerviz- Analytics.png',
  security: 'IconZerviz- seguridad ok.png',
  channels: 'IconZerviz- Seamless Channel.png',
  cloud: 'IconZerviz- cloud.png',
};

interface ChannelIconProps {
  kind: IconKind;
  size?: number;
  alt?: string;
  className?: string;
}

export function ChannelIcon({ kind, size = 24, alt, className }: ChannelIconProps): JSX.Element {
  const filename = ICON_MAP[kind];
  // encodeURI para nombres con espacios ("IconZerviz- Harmony.png").
  const src = `/icons/${encodeURI(filename)}`;
  return (
    <img
      src={src}
      width={size}
      height={size}
      alt={alt ?? `${kind} icon`}
      className={className}
      loading="lazy"
      style={{ display: 'inline-block', verticalAlign: 'middle', objectFit: 'contain' }}
    />
  );
}

/** Helper: mapea ChannelType del domain a IconKind. */
export function iconKindFromChannelType(
  channelType: string,
): IconKind {
  switch (channelType) {
    case 'whatsapp': return 'whatsapp';
    case 'webchat': return 'webchat';
    case 'notifications': return 'notifications';
    case 'messenger':
    case 'instagram': return 'meta';
    case 'five9': return 'api';
    default: return 'channels';
  }
}
